module.exports = __webpack_public_path__ + "employee_white.8f558c37a5604788e461.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/employee_white.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/employee_white.svg
// module chunks = styles